module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar address = model.dataJSON || {};\nvar lines = [], lineParts = [];\nvar namePrefix = '';\nif(address.company){\nlines.push(address.company);\nif(address.firstname || address.lastname){\nnamePrefix = 'z.H.:'\n}\n}\nif(address.firstname || address.lastname){\nlineParts = [];\nif(namePrefix)          lineParts.push(namePrefix);\nif(address.salutation)  lineParts.push(address.salutation);\nif(address.firstname)   lineParts.push(address.firstname);\nif(address.lastname)    lineParts.push(address.lastname);\nlines.push(lineParts.join(' '));\n}\nif(address.street){\nlines.push(address.street);\n}\nif(address.zip || address.city){\nlineParts = [];\nif(address.zip)     lineParts.push(address.zip);\nif(address.city)    lineParts.push(address.city);\nlines.push(lineParts.join(' '));\n}\nif(address.state){\nlines.push(address.state);\n}\nif(address.phone || address.email || address.uid){\nif(address.phone)   lines.push(`Tel: ${address.phone}`);\nif(address.email)   lines.push(`Email: ${address.email}`);\nif(address.uid)     lines.push(`UID: ${address.uid}`);\n}\n%>\n<div>\n<%\nif(lines.length > 0){\n%><ol><%\nfor(var line of lines){\n%><li><%= line %></li><%\n}\n%></ol><%\n} else {\n%><p><%= storage.__('order.properties.address.empty') %></p><%\n}\n%>\n</div>"
  , __filename = "components/templates/ttgShop/orders/fields/address.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var address = model.dataJSON || {};
var lines = [], lineParts = [];
var namePrefix = '';
if(address.company){
lines.push(address.company);
if(address.firstname || address.lastname){
namePrefix = 'z.H.:'
}
}
if(address.firstname || address.lastname){
lineParts = [];
if(namePrefix)          lineParts.push(namePrefix);
if(address.salutation)  lineParts.push(address.salutation);
if(address.firstname)   lineParts.push(address.firstname);
if(address.lastname)    lineParts.push(address.lastname);
lines.push(lineParts.join(' '));
}
if(address.street){
lines.push(address.street);
}
if(address.zip || address.city){
lineParts = [];
if(address.zip)     lineParts.push(address.zip);
if(address.city)    lineParts.push(address.city);
lines.push(lineParts.join(' '));
}
if(address.state){
lines.push(address.state);
}
if(address.phone || address.email || address.uid){
if(address.phone)   lines.push(`Tel: ${address.phone}`);
if(address.email)   lines.push(`Email: ${address.email}`);
if(address.uid)     lines.push(`UID: ${address.uid}`);
}

    ; __line = 36
    ; __append("\n<div>\n")
    ; __line = 38
    ; 
if(lines.length > 0){

    ; __line = 40
    ; __append("<ol>")
    ; 
for(var line of lines){

    ; __line = 42
    ; __append("<li>")
    ; __append(escapeFn( line ))
    ; __append("</li>")
    ; 
}

    ; __line = 44
    ; __append("</ol>")
    ; 
} else {

    ; __line = 46
    ; __append("<p>")
    ; __append(escapeFn( storage.__('order.properties.address.empty') ))
    ; __append("</p>")
    ; 
}

    ; __line = 48
    ; __append("\n</div>")
    ; __line = 49
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/ttgShop/orders/fields/address.ejs

}